// Components imports
import ResultsRenderer from "./components/ResultsRenderer";

// React instances
global.React = require("react");
global.ReactDOM = require("react-dom");
global.ReactDOMServer = require("react-dom/server");

// Components
global.ResultsRenderer = ResultsRenderer;